import React from 'react'

import { ImageFeatures } from 'sdk'
import { SimpleSection } from 'sdk/sections'

import { useWindowSize } from 'core/hooks/useWindowSize'
import type { SdkCustomSolutionsCmsContent } from 'core/services/cms/interfaces'

interface CustomSolutionsSectionProps {
  content: SdkCustomSolutionsCmsContent
}

export const CustomSolutionsSection: React.FC<CustomSolutionsSectionProps> = ({ content }) => {
  const { width } = useWindowSize()

  const getResponsiveImage = (): string => {
    if (width <= 375) {
      return content.imageMobileUrl
    }

    if (width < 768) {
      return content.imageTabletUrl
    }

    return content.imageDesktopUrl
  }

  return (
    <SimpleSection
      title={content.title}
      subtitle={content.subtitle}
    >
      <ImageFeatures
        image={getResponsiveImage()}
        features={content.features.map((feature) => ({
          icon: feature.iconUrl,
          title: feature.title,
          description: feature.description,
        }))}
      />
    </SimpleSection>
  )
}
